import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// import Select from "reactize-selectize";
import { ImageUpload } from 'components';
import { ReactComponent as CloseCircle } from 'assets/svg/close-circle-line.svg';
import { ReactComponent as PhotoSvg } from 'assets/svg/photo-line.svg';
import { ReactComponent as Mail } from 'assets/svg/mail-line.svg';
// import { ReactComponent as Smiley } from 'assets/svg/smiley-line.svg';
import { ReactComponent as Add } from 'assets/svg/add-multi-line.svg';
import { ReactComponent as SettingsSvg } from 'assets/svg/settings-line.svg';

export const CreateTread = props => {
  const [file, setFile] = useState();
  const [preview, setPreview] = useState('');

  const onSubmit = e => {
    e.preventDefault();
  };

  const onImageChange = e => {
    const image = e.target.files[0];
    setFile(image);
    setPreview(URL.createObjectURL(image));
  };

  return (
    <div
      className={classnames('comments', {
        show: props.show
      })}
    >
      <div className="comments__left">
        <div className="comments__overlay" onClick={props.toggle} />
      </div>
      <div className="comments__side">
        <div className="modal__header modal__header--settings">
          <div className="modal__footer__item">
            <span className="modal__title--text">
              {props.start ? 'Start A Tread' : 'Manage Tread'}
            </span>
          </div>
          <div className="modal__footer__item">
            {props.start ? (
              <SettingsSvg
                style={{ height: '18px', cursor: 'pointer' }}
                onClick={props.toggle}
              />
            ) : null}
            <CloseCircle
              className=""
              style={{ cursor: 'pointer' }}
              onClick={props.toggle}
            />
          </div>
        </div>
        <form onSubmit={onSubmit} className="form">
          <ImageUpload onChange={onImageChange} preview={preview} />
          <div className="form__group">
            <label className="form__label" htmlFor="title">
              Tread Title
            </label>

            <input
              className="form__field"
              type="text"
              name="title"
              id="title"
              placeholder="Enter title"
              maxLength="35"
              // value={fullName}
              // onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div className="form__group">
            <label className="form__label" htmlFor="category">
              Tread Category
            </label>
            <select
              className="form__field form__select"
              name="category"
              id="category"
            >
              <option value="">Select Category</option>
              <option value="fashion">Fashion</option>
              <option value="crypto">Crypto</option>
              <option value="maker">Maker</option>
              <option value="tv">TV</option>
              <option value="bet">Betting</option>
              <option value="write">Writer</option>
              <option value="write">General</option>
            </select>
          </div>

          <div className="button__container button__container--center">
            {props.start ? (
              <button className="button button__primary button__auto">
                <span>Next </span>
              </button>
            ) : (
              <button className="button button__primary button__auto">
                <span>Save </span>
              </button>
            )}
          </div>
        </form>
        {props.start ? (
          <>
            <div className="modal__input">
              <div className="modal__progress" />
              <textarea
                placeholder="What's on your mind?"
                name=""
                id=""
                maxLength="280"
              />
            </div>

            <div className="modal__footer modal__reply">
              <div className="modal__footer__item modal__footer__count">
                {/* <span>0 / 280</span> */}
                <Add />
                <PhotoSvg />
              </div>
              <div className="modal__footer__item">
                <Mail />
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

CreateTread.propTypes = {
  show: PropTypes.bool,
  start: PropTypes.bool,
  toggle: PropTypes.func
};
